import React from "react";
import classnames from "classnames";
// import { useDealSectionsSelector } from "../../../store";

import "./MoveToFolder.styles.scss";
import { IFolder } from "store/types";
import { useFoldersSelect } from "store";
import { FolderItem } from "./FolderItem";

export interface IMoveToFolder {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  sendData: (sectionId: number) => void;
}

export const MoveToFolder: React.FC<IMoveToFolder> = ({ isOpen, setIsOpen, sendData }) => {
  const parentFolders = useFoldersSelect({ kind: "folder", parent_id: null });

  return (
    <div
      className={classnames("move", "opacity-appearance", {
        "move--open": isOpen
      })}
    >
      {parentFolders?.length ? (
        parentFolders?.map((folder: IFolder) => (
          <FolderItem key={folder.id} folder={folder} setIsOpen={setIsOpen} sendData={sendData} subFolder={1} />
        ))
      ) : (
        <div
          className="move-to-folder flex-row-fc-fc"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          <span>No available folders</span>
        </div>
      )}
    </div>
  );
};
